import { RTree2D } from "flux-core";

/**
 * Holds the zIndexs of shapes in a spatial structure.
 * shapes are placed in the x axis by it's zIndex and
 * The neighbours from -Infinity in the axis will provide the
 * items sorted by zIndex
 */
export class ShapesZIndexTreeCache extends RTree2D{

    /**
     * Made it as singleton.
     */
    public static get instance(): ShapesZIndexTreeCache {
        if( !ShapesZIndexTreeCache._instance ) {
            ShapesZIndexTreeCache._instance = new ShapesZIndexTreeCache();
        }
        return ShapesZIndexTreeCache._instance;
    }

    /**
     * Holds the singleton instance of ShapesZIndexTreeCache
     */
    private static _instance = null;

    /**
     * Expected minimum Z index.
     */
    protected MIN_Z_INDEX = -100000;

    /**
     * Constructor is private so that it cannot be instanciated from outside of this class.
     */
    private constructor() {
        super();
    }

    /**
     * Get shapes Ordered by their Z index.
     * Important! : This tree needs to be populated before use this method
     * @returns 
     */
    public getShapesOrderedByIndex() {
        // Should pass Number.MIN_SAFE_INTEGER or -Infinity but those 2 values
        // are not working
        return this.getNeighbors( this.MIN_Z_INDEX, 0 );
    }
}